import produce from 'immer';
import * as actions from './actions';

export const initialState = {
  newsletter: { data: null, loading: false, error: null },
  survey: { data: null, loading: false, error: null },
  individual: { data: null, loading: false, error: null },
  target: { data: null, loading: false, error: null },
  response: { data: null, loading: false, error: null },
};

const reducer = (state = initialState, action) => produce(state, (draft) => {
  switch (action.type) {
    case actions.FETCH_NEWSLETTER_REQUEST:
      draft.newsletter.loading = true;
      break;
    case actions.FETCH_NEWSLETTER_SUCCESS:
      draft.newsletter.loading = false;
      draft.newsletter.data = action.payload.newsletter;
      break;
    case actions.FETCH_NEWSLETTER_FAILURE:
      draft.newsletter.loading = false;
      draft.newsletter.error = action.payload.error;
      break;
    case actions.FETCH_SURVEY_REQUEST:
      draft.survey.loading = true;
      break;
    case actions.FETCH_SURVEY_SUCCESS:
      draft.survey.loading = false;
      draft.survey.data = action.payload.survey;
      break;
    case actions.FETCH_SURVEY_FAILURE:
      draft.survey.loading = false;
      draft.survey.error = action.payload.error;
      break;
    case actions.FETCH_INDIVIDUAL_REQUEST:
      draft.individual.loading = true;
      break;
    case actions.FETCH_INDIVIDUAL_SUCCESS:
      draft.individual.loading = false;
      draft.individual.data = action.payload.individual;
      break;
    case actions.FETCH_INDIVIDUAL_FAILURE:
      draft.individual.loading = false;
      draft.individual.error = action.payload.error;
      break;
    case actions.FETCH_TARGET_REQUEST:
      draft.target.loading = true;
      break;
    case actions.FETCH_TARGET_SUCCESS:
      draft.target.loading = false;
      draft.target.data = action.payload.target;
      break;
    case actions.FETCH_TARGET_FAILURE:
      draft.target.loading = false;
      draft.target.error = action.payload.error;
      break;
    case actions.CREATE_RESPONSE_REQUEST:
      draft.response.loading = true;
      break;
    case actions.CREATE_RESPONSE_SUCCESS:
      draft.response.loading = false;
      draft.response.data = true;
      break;
    case actions.CREATE_RESPONSE_FAILURE:
      draft.response.loading = false;
      draft.response.error = action.payload.error;
      break;
    case actions.UPDATE_RESPONSE_REQUEST:
      draft.response.loading = true;
      break;
    case actions.UPDATE_RESPONSE_SUCCESS:
      draft.response.loading = false;
      draft.response.data = true;
      break;
    case actions.UPDATE_RESPONSE_FAILURE:
      draft.response.loading = false;
      draft.response.error = action.payload.error;
      break;
    case actions.CLEAR_NEWSLETTER_ERROR:
      draft.newsletter.error = null;
      break;
    case actions.CLEAR_SURVEY_ERROR:
      draft.survey.error = null;
      break;
    case actions.CLEAR_INDIVIDUAL_ERROR:
      draft.individual.error = null;
      break;
    case actions.CLEAR_TARGET_ERROR:
      draft.target.error = null;
      break;
    case actions.INIT_TARGET:
      draft.target = { data: null, loading: false, error: null };
      break;
    case actions.INIT_INDIVIDUAL:
      draft.individual = { data: null, loading: false, error: null };
      break;
    case actions.INIT_RESPONSE:
      draft.response = { data: null, loading: false, error: null };
      break;
    case actions.INIT_NEWSLETTERS:
      draft.newsletter = { data: null, loading: false, error: null };
      break;
    default:
  }
});

export default reducer;
